import { Link } from 'react-scroll';

export function MenuTop() {
    const menuItems = [
        { to: 'carnes', label: 'Carnes' },
        { to: 'entradas', label: 'Entradas' },
        { to: 'porções', label: 'Porções' },
        { to: 'acompanhamentos', label: 'Acompanhamentos' },
        { to: 'bebidas', label: 'Bebidas' },
        { to: 'drinks', label: 'Drinks' },
        { to: 'sobremesas', label: 'Sobremesas' }
    ];

    const handleKeyDown = (event, to) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault(); // Evita o comportamento padrão da tecla Space
            const targetElement = document.getElementById(to);
            if (targetElement) {
                const yOffset = -120; // Ajuste para compensar o menu fixo
                const y = targetElement.getBoundingClientRect().top + window.scrollY + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        }
    };

    return (
        <div
            id='top'
            className='flex flex-nowrap justify-start mt-[2px] pt-2 pb-1 w-full bg-[#F9F4F1] uppercase text-[#FAE374] overflow-auto sticky top-[52px] md:justify-between'
            role='menubar'
            aria-label='Menu principal'
        >
            {menuItems.map((item) => (
                <Link
                    key={item.to}
                    to={item.to}
                    spy={true}
                    smooth={true}
                    offset={-120}
                    duration={500}
                    className='text-base font-bold cursor-pointer m-1 p-2 bg-[#A72525] rounded-md hover:bg-[#CC3333]'
                    role='menuitem'
                    aria-label={`Ir para ${item.label}`}
                    tabIndex={0} // Permite foco via teclado
                    onKeyDown={(event) => handleKeyDown(event, item.to)}
                >
                    {item.label}
                </Link>
            ))}
        </div>
    );
}

export default MenuTop;